import React from "react";
import Common_title from "../common/common-title/Common_title";

function Privacy_Policy() {
  return (
    <>
      <section className="Terms_And_Condition bg_img_holder">
        <div className="container">
          <Common_title headingText="Privacy" spanText="Policy" />

          <div className="policy_holder">
            <div className="text_holder">
              <h3>1. Introduction</h3>
              <p>
                RentEasy respects your privacy and is committed to protecting
                your personal data. This Privacy Policy explains how we collect,
                use, and safeguard your information when you use{" "}
                <span>renteasyapp.in</span> or the RentEasy mobile application.
              </p>
            </div>

            <div className="text_holder">
              <h3>2. Information We Collect</h3>
              <p>
                <b>Personal Information</b>
              </p>
              <ul>
                <li>Name</li>
                <li>Mobile Number</li>
                <li>Email Address</li>
                <li>Residential Address</li>
                <li>ID Proofs</li>
                <li>Photograph</li>
              </ul>

              <p>
                <b>Property Information</b>
              </p>
              <ul>
                <li>Property or room details</li>
                <li>Rent amount</li>
                <li>Tenant information</li>
              </ul>

              <p>
                <b>Financial Information</b>
              </p>
              <ul>
                <li>Payment history</li>
                <li>Transaction details</li>
                <li>Subscription payments</li>
              </ul>

              <p>
                <b>Technical Information</b>
              </p>
              <ul>
                <li>Device information</li>
                <li>IP address</li>
                <li>App usage logs</li>
              </ul>
            </div>

            <div className="text_holder">
              <h3>3. Purpose of Data Collection</h3>
              <p>Your data may be used for the following purposes:</p>
              <ul>
                <li>Account creation and login authentication</li>
                <li>Processing rent payments</li>
                <li>Generating invoices and payment records</li>
                <li>Sending notifications and reminders</li>
                <li>Providing customer support</li>
                <li>Legal and regulatory compliance</li>
                <li>Fraud prevention and security monitoring</li>
              </ul>
            </div>

            <div className="text_holder">
              <h3>4. KYC & Legal Compliance Policy</h3>

              <p>
                <b>Who Must Complete KYC</b>
              </p>
              <ul>
                <li>
                  Owners/Admins before receiving rent or activating
                  subscriptions
                </li>
                <li>Tenants before paying rent or using platform services</li>
              </ul>

              <p>
                <b>Documents Required</b>
              </p>
              <ul>
                <li>
                  ID Proof (Aadhaar, PAN, Passport, Driving License, Voter ID)
                </li>
                <li>
                  Address Proof (Aadhaar, Utility Bill, Rent Agreement, Bank
                  Statement)
                </li>
                <li>Selfie or photograph verification</li>
                <li>OTP verification</li>
                <li>Bank account or UPI details</li>
                <li>Property ownership proof (for owners if required)</li>
              </ul>

              <p>
                <b>How Verification is Done</b>
              </p>
              <ul>
                <li>OTP authentication</li>
                <li>Document upload verification</li>
                <li>Selfie or live photo matching</li>
                <li>Manual or third-party verification checks</li>
              </ul>

              <p>
                <b>Why We Collect KYC</b>
              </p>
              <ul>
                <li>Identity verification</li>
                <li>Fraud prevention</li>
                <li>Secure rent payment processing</li>
                <li>Legal and regulatory compliance</li>
              </ul>

              <p>
                <b>User Consent</b>
              </p>
              <p>
                By registering on the platform, you agree to provide accurate
                KYC details and allow verification. Submission of false
                information may result in account suspension or legal action.
              </p>

              <p>
                <b>Data Safety</b>
              </p>
              <ul>
                <li>KYC documents are encrypted and securely stored</li>
                <li>Access is restricted to authorized personnel only</li>
                <li>Data is retained only as required by law</li>
                <li>Personal data is never sold</li>
              </ul>

              <p>
                <b>Non-Compliance</b>
              </p>
              <p>
                Incomplete or failed KYC may result in restricted platform
                features, blocked payments, or account suspension.
              </p>
            </div>

            <div className="text_holder">
              <h3>5. Data Security</h3>
              <p>We implement industry-standard security measures including:</p>
              <ul>
                <li>Encrypted transactions</li>
                <li>OTP-based authentication</li>
                <li>Secure cloud storage</li>
                <li>Restricted system access control</li>
              </ul>
            </div>

            <div className="text_holder">
              <h3>6. Data Sharing</h3>
              <p>We do not sell your personal data.</p>
              <p>Your information may only be shared with:</p>
              <ul>
                <li>Payment gateway partners</li>
                <li>KYC verification service providers</li>
                <li>Legal or regulatory authorities when required by law</li>
              </ul>
            </div>

            <div className="text_holder">
              <h3>7. Data Retention</h3>
              <p>
                Personal information is retained for as long as your account
                remains active or as required by applicable legal and regulatory
                obligations.
              </p>
            </div>

            <div className="text_holder">
              <h3>8. Cookies & Tracking</h3>
              <p>
                We may use cookies and analytics tools to improve user
                experience, monitor platform performance, and enhance
                application functionality.
              </p>
            </div>

            <div className="text_holder">
              <h3>9. User Rights</h3>
              <p>Users have the right to:</p>
              <ul>
                <li>Update their personal information</li>
                <li>Request corrections to inaccurate data</li>
                <li>Request account deletion</li>
                <li>Contact support for privacy-related concerns</li>
              </ul>
            </div>

            <div className="text_holder">
              <h3>10. Policy Updates</h3>
              <p>
                RentEasy may update this Privacy Policy from time to time.
                Continued use of the platform after updates indicates acceptance
                of the revised policy.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy_Policy;
